

import './App.css';
import React, { useState, useEffect,useRef } from "react";
import { CredentialComponent } from './components/credentials';
import RouteStack from './utils/routeStack';
import { Toast } from 'primereact/toast';
import 'primeicons/primeicons.css';
const SESSION_TIMEOUT = 10000; // 15 minutes in milliseconds (adjust as needed)
const WARNING_TIMEOUT = 5000; // 2 minutes in milliseconds
let idleTimeout;
const App = () => {
  const toast = useRef(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const showWarn = (secondsLeft) => {
    toast.current.show({severity:'warn', summary: 'Warning', detail:`Your Session Will Expire in ${secondsLeft} Seconds.`});
  }
  const resetIdleTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(logoutUser, SESSION_TIMEOUT);
    // Set a timer for the warning
    setTimeout(() => {
      let warningTime = SESSION_TIMEOUT - WARNING_TIMEOUT;
      let countdownInterval = setInterval(() => {
        console.log("inside setInterval")
        let secondsLeft = Math.ceil(warningTime / 1000);
        console.log("secoond left",secondsLeft)
        if (secondsLeft > 0) {
          console.log("second left in session logout",secondsLeft)
          // showWarn(secondsLeft);
           
          
            toast.current.show({severity:'warn', summary: 'Warning', detail:`Your Session Will Expire in ${secondsLeft} Seconds.`});
          
        //  alert(`Your session will Expire in ${secondsLeft} seconds.`);
        }
        warningTime -= 1000;
        if (warningTime < 0) {
          console.log("inside warning")
          clearInterval(countdownInterval);
        }
      }, 1000);
    }, WARNING_TIMEOUT);
  };

  const logoutUser = () => {
    // Perform the logout action, e.g., clear session/token, redirect to a logout page.
    // Update local storage or any other necessary actions.
    // localStorage.clear(); // Clear local storage (you may want to implement this based on your needs)
    // setIsAuthenticated(false);
    // window.location.href = '/login'; // Redirect to the login page
    // console.log('User logged out due to inactivity.');

    // console.log("inside session logout");
    // alert("session logout")
  };

  const handleUserActivity = () => {
    resetIdleTimer();
    // You can also perform other actions to handle user activity here.
  };

  useEffect(() => {
    
    const data = localStorage.getItem('data');
    if (data === 'true') {
      setIsAuthenticated(true);
      // resetIdleTimer();
      // document.addEventListener('mousemove', handleUserActivity);
      // document.addEventListener('keydown', handleUserActivity);
    }

    // return () => {
    //   clearTimeout(idleTimeout);
    //   document.removeEventListener('mousemove', handleUserActivity);
    //   document.removeEventListener('keydown', handleUserActivity);
    // };
  }, []);

  return (
    <CredentialComponent.Provider
      value={{ isAuthenticated, setIsAuthenticated }}>
      <Toast ref={toast} position="top-center"/>
      <RouteStack />
    </CredentialComponent.Provider>
  );
};

export default App;



